import css from "standard/css";

const style = css`
  .performance {
    width: 500px !important;
    height: 500px;
  }
`;

export default style;
